export default __webpack_public_path__ + "static/media/Raffaella_Final_Menu_Print.fa32ca65.pdf";